module.exports = __webpack_public_path__ + "static/img/ship2.310eea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ship2.jpg
// module id = vsgi
// module chunks = 0